export default {
  refresh () {
    location.reload()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/global.js